import { render, staticRenderFns } from "./task-datas-list.vue?vue&type=template&id=1dec3f68&scoped=true&"
import script from "./task-datas-list.vue?vue&type=script&lang=js&"
export * from "./task-datas-list.vue?vue&type=script&lang=js&"
import style0 from "./task-datas-list.vue?vue&type=style&index=0&id=1dec3f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec3f68",
  null
  
)

export default component.exports